'use strict';

module.exports = {
    BAD_REQUEST: 'bad.request',
    HOT_FOLDER_ALREADY_MONITORING: 'hotfolder.alreadyMonitoringError',
    TRANSFER_NOT_FOUND: 'transfer.not.found',
    RELAY_ID_NOT_FOUND: 'relayid.not.found'
};